import React, { useState, useEffect } from 'react'

import { string, array } from 'prop-types'

import { newHomepageService } from 'Pods/NewHomepage/Services/newHomepageService'

import PrintModelsBase from './components/PrintModelsBase'

function PrintModels({ data, title, mobileTitle = '', description, link, className = '', buttonText }) {
  const [isHydrated, setIsHydrated] = useState(false)
  const [models, setModels] = useState(data)
  const isTrendingSection = className.includes('printable-section__trending')

  useEffect(() => {
    setIsHydrated(true)
  }, [])

  useEffect(() => {
    if (!isTrendingSection) {
      setModels(data)

      return
    }

    let isMounted = true
    const fetchTrendingModels = async () => {
      try {
        const trendingModels = await newHomepageService.getPrintTrendingModels(10)

        if (isMounted && Array.isArray(trendingModels)) {
          setModels(trendingModels)
        }
      } catch (error) {
        if (isMounted) {
          setModels(data)
        }
      }
    }

    fetchTrendingModels()

    return () => {
      isMounted = false
    }
  }, [data, isTrendingSection])

  const activeModels = isTrendingSection ? models : data

  return (
    <PrintModelsBase
      models={activeModels}
      title={title}
      mobileTitle={mobileTitle}
      description={description}
      link={link}
      className={className}
      buttonText={buttonText}
      isHydrated={isHydrated}
    />
  )
}

PrintModels.propTypes = {
  title: string.isRequired,
  mobileTitle: string,
  description: string.isRequired,
  link: string.isRequired,
  data: array.isRequired,
  className: string,
  buttonText: string.isRequired,
}

export default PrintModels
